import React from 'react';
import { Switch, Checkbox } from '@material-ui/core';
export default { switch: (props) => <Switch {...props} />, checkbox: (props) => <Checkbox {...props} /> }
